import { EmailTracker } from "app/components/email-tracker/EmailTracker";

import type { ILinkProviderProps } from "../../../components/WithLink/src/LinkProvider";
import { LinkProvider } from "../../../components/WithLink/src/LinkProvider";

const AllContexts = ({ linkFn, children }: ILinkProviderProps) => (
    <>
        <EmailTracker />
        <LinkProvider linkFn={linkFn}>{children}</LinkProvider>
    </>
);

export default AllContexts;
